export default "__VITE_ASSET__C0M07Cxw__"